import { removeProp } from '../utils/remove-prop';
import { replacePropName } from '../utils/replace-prop-name';

import { findMigrationIcons } from './find-migration-icons';
import { updateImports } from './update-imports';

export const CODE_TRANSFORM_ID_MIGRATION_ICONS = 'migration-icons';

const TRANSFORM_CONFIG = {
	BOTH: {
		REMOVE_PROPS: ['LEGACY_margin', 'LEGACY_fallbackIcon'],
		REPLACE_PROPS: [],
	},
	NEW: {
		REMOVE_PROPS: ['LEGACY_primaryColor', 'LEGACY_secondaryColor', 'LEGACY_size'],
		REPLACE_PROPS: [],
	},
	LEGACY: {
		REMOVE_PROPS: ['spacing', 'color', 'size'],
		REPLACE_PROPS: [
			{
				from: 'LEGACY_primaryColor',
				to: 'primaryColor',
			},
			{
				from: 'LEGACY_secondaryColor',
				to: 'secondaryColor',
			},
			{
				from: 'LEGACY_size',
				to: 'size',
			},
		],
	},
};

export const transformMigrationIcons = (sourceCode: string, to: 'legacy' | 'new') => {
	let transformedCode = sourceCode;

	const migrationIcons = findMigrationIcons(transformedCode);

	transformedCode = updateImports(transformedCode, to);

	const propRemovals = [
		...TRANSFORM_CONFIG.BOTH.REMOVE_PROPS,
		...(to === 'new' ? TRANSFORM_CONFIG.NEW.REMOVE_PROPS : TRANSFORM_CONFIG.LEGACY.REMOVE_PROPS),
	];

	// Remove props
	migrationIcons.forEach(({ componentName }) => {
		propRemovals.forEach((prop) => {
			transformedCode = removeProp(transformedCode, { prop, componentName });
		});
	});

	const propReplacements = [
		...TRANSFORM_CONFIG.BOTH.REPLACE_PROPS,
		...(to === 'new' ? TRANSFORM_CONFIG.NEW.REPLACE_PROPS : TRANSFORM_CONFIG.LEGACY.REPLACE_PROPS),
	];

	// Replace props
	migrationIcons.forEach(({ componentName }) => {
		propReplacements.forEach((prop) => {
			transformedCode = replacePropName(transformedCode, {
				componentName,
				oldProp: prop.from,
				newProp: prop.to,
			});
		});
	});

	return transformedCode;
};
